import { Icon } from '../../components/icon';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles } from '../../components/theme';
import { ClassNames, Style } from './hidden.image.icon.style';

addStyles(Style);

export const HiddenImageIcon = {
	view(opts: { position: keyof typeof ClassNames.position } = { position: 'center' }) {
		return Icon.view(MaterialIcon.VISIBILITY_OFF, {
			className: `${ClassNames.icon} ${ClassNames.position[opts.position]}`,
		});
	},
};
